// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3356e5c3","239":"36da8cc6","264":"e92c8ba7","429":"fcf51e98","455":"4c9de5dd","480":"32682487","638":"bd73dc40","854":"55a86890"}[chunkId] + ".chunk.js";
};